import { Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, title, sub, image, testid = "page-hero" }) => (
  <section className="relative overflow-hidden bg-ink pb-24 pt-40" data-testid={testid}>
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/60" />
      </>
    )}
    <div className="relative mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        {eyebrow && <p className="eyebrow-dark">{eyebrow}</p>}
        <h1 className="mt-4 max-w-3xl font-display text-5xl leading-[1.05] tracking-tight text-offwhite md:text-6xl">
          {title}
        </h1>
        {sub && <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70">{sub}</p>}
        <div className="mt-10 h-px w-24 bg-gold" />
      </Reveal>
    </div>
  </section>
);
